import moment from "moment";
import { exportToExcel } from "../../../../common-utilities/utils";
export const downloadPO = (poData) => {
  const data =
    poData?.items?.map?.((item) => {
      return {
        "Item Code": item?.itemCode || null,
        Description: item?.itemDescription || null,
        UOM: item?.uom || null,
        Type: item?.type || null,
        CaseSize: item?.caseSize || null,
        Quantity: item?.quantity != undefined ? item?.quantity : null,
        // "Inward Qty":
        //   item?.inwardedQuantity != undefined ? item?.inwardedQuantity : null,
        Price: item?.rate != undefined ? item?.rate : null,
        Amount: item?.amount != undefined ? item?.amount : null,
        "Tax rate": item?.taxRate != undefined ? item?.taxRate : null,
        "Tax Amount": item?.taxAmount != undefined ? item?.taxAmount : null,
        "Total Amount":
          item?.totalAmount != undefined ? item?.totalAmount : null,
      };
    }) || [];

  exportToExcel(data, "po", null, true);
};

export const downloadReports = (data, status) => {
  let results = data;
  if (!data?.length) {
    return;
  } else {
    results = data?.map((ele) => ({
      "GRN No.": ele?.grnNo,
      "PO Number": ele?.poNumber,
      "Created At": moment(ele?.createdAt).format("DD-MM-YYYY"),
      "Creator Name": ele?.creatorName,
      Amount: ele?.amount,
      "Tax Amount": ele?.taxAmount,
      "Total Amount": ele?.totalAmount,
      "Invoice Date": moment(ele?.invoiceDate).format("DD-MM-YYYY"),
      "Invoice Number": ele?.invoiceNumber,
      "Inward Date": moment(ele?.inwardDate).format("DD-MM-YYYY"),
      "Pending With Role": ele?.pendingWithRole,
      Status: ele?.status,
      Remarks: ele?.remarks,
    }));
  }

  exportToExcel(results, "grn_report");
};
